import EventEmitter from 'events';

const eventEmitter3 = new EventEmitter();

export default eventEmitter3;
